module.exports = __webpack_public_path__ + "static/media/22ESCWA22.d1cb5e99.jpg";